import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withModifiers as _withModifiers, withCtx as _withCtx, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "tags-view-container"
};
import { useRoute } from 'vue-router';
import ContextMenu from './ContextMenu/index.vue';
import { useStore } from 'vuex';
import { ref, reactive, watch } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const selectIndex = ref(0);
    const visible = ref(false);
    const menuStyle = reactive({
      left: 0,
      top: 0
    });
    const openMenu = (e, index) => {
      const {
        x,
        y
      } = e;
      menuStyle.left = x + 'px';
      menuStyle.top = y + 'px';
      selectIndex.value = index;
      visible.value = true;
    };
    /**
     * 是否被选中
     */
    const isActive = tag => {
      return tag.path === route.path;
    };

    /**
     * 关闭 tag 的点击事件
     */
    const store = useStore();
    const onCloseClick = index => {
      store.commit('app/removeTagsView', {
        type: 'index',
        index: index
      });
    };
    const closeMenu = () => {
      visible.value = false;
    };
    watch(visible, val => {
      if (val) {
        document.body.addEventListener('click', closeMenu);
      } else {
        document.body.removeEventListener('click', closeMenu);
      }
    });
    return (_ctx, _cache) => {
      const _component_Close = _resolveComponent("Close");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_scrollbar, {
        class: "tags-view-wrapper"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.tagsViewList, (tag, index) => {
          return _openBlock(), _createBlock(_component_router_link, {
            class: _normalizeClass(["tags-view-item", isActive(tag) ? 'active' : '']),
            style: _normalizeStyle({
              backgroundColor: isActive(tag) ? _ctx.$store.getters.cssVar.menuBg : '',
              borderColor: isActive(tag) ? _ctx.$store.getters.cssVar.menuBg : ''
            }),
            key: tag.fullPath,
            to: {
              path: tag.fullPath
            },
            onContextmenu: _withModifiers($event => openMenu($event, index), ["prevent"])
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(tag.title) + " ", 1), _withDirectives(_createVNode(_component_el_icon, {
              class: "el-icon-close",
              onClick: _withModifiers($event => onCloseClick(index), ["prevent", "stop"])
            }, {
              default: _withCtx(() => [_createVNode(_component_Close)]),
              _: 1
            }, 8, ["onClick"]), [[_vShow, !isActive(tag)]])]),
            _: 2
          }, 1032, ["class", "style", "to", "onContextmenu"]);
        }), 128))]),
        _: 1
      }), _withDirectives(_createVNode(ContextMenu, {
        style: _normalizeStyle(menuStyle),
        index: selectIndex.value
      }, null, 8, ["style", "index"]), [[_vShow, visible.value]])]);
    };
  }
};